<template>
  <v-app-bar
    id="app-toolbar"
    app
    dark
    fixed
    color="grey darken-3"
  >
    <v-app-bar-nav-icon @click="$store.commit('app/DRAWER_TOGGLE')" />

    <!-- LOGO -->
    <a
      v-if="$vuetify.breakpoint.mdAndUp"
      id="logo"
      title="WhaleWisdom Home Page"
      href="/"
    >
      <img
        src="@/assets/images/main-logo.png"
        alt="WhaleWisdom logo"
      >
    </a>

    <!-- TEST BREAKPOINT INDICATOR -->
    <!-- <div class="text-h5 text-uppercase ml-2">{{ $vuetify.breakpoint.name }}</div> -->
    <!-- END TEST BREAKPOINT INDICATOR -->

    <v-spacer />
    <toolbar-search />
    <v-spacer />
    <toolbar-frequently-used />
    <toolbar-account />
  </v-app-bar>
</template>

<script>
// Components
import ToolbarSearch from './toolbar/_Search'
import ToolbarFrequentlyUsed from './toolbar/_FrequentlyUsed'
import ToolbarAccount from './toolbar/_Account'

export default {
  components: {
    ToolbarSearch,
    ToolbarFrequentlyUsed,
    ToolbarAccount
  }
}
</script>

<style lang="scss">
#app-toolbar {
  #logo img {
    height: 32px;
    vertical-align: middle;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
